<template>
	<div class="table-responsive">
		<table class="table table-bordered loadable table-xs" >
			<thead>
				<!-- <tr > -->
					<th v-for="(head, index) in headers" :key="index">{{head}}</th>

				<!-- </tr> -->
			</thead>
					<tbody v-if="body.length>0">
						<tr class="session_table" v-for="(item, index) in body" :key="index">
							<td class="clickable"><a class="cursor-pointer" @click="openSession(item)">{{item.name}}</a></td>
							<td>{{item.supervisor}}</td>
							<td>{{item.scheduled_at.split(' ')[0]}}</td>
							<td>{{item.providers_count}}</td>
							<td v-if="section =='scheduled'" @click="openSessionPlayer(item)"><a class="hyper_button" @click="openSessionPlayer(item)">Play</a> </td>
							<td v-if="section =='active'">
								 <a class="hyper_button mr-1" @click="openSessionPlayer(item)">Resume</a> 
								 <a class="hyper_button ml-1" @click="openCompleteModal(item)">Complete</a>
								 </td>
							<td v-if="section =='completed'"> {{item.completed_at}}</td>

							<td v-if="section =='completed'" class=""> 
								<!-- <div class="progress-icon download ml-1" @click="downloadCert(item.certificates_url)"> 
								</div> -->
								<a class="hyper_button ml-2" @click="downloadCert(item.certificates_url)"> 
									<img class="ml-1" src="../../assets/images/icons/solid/file-archive.svg" width="18"/>
								</a>
							</td>

							<td v-if="section =='completed'" class=""  @click="downloadCert(item.report_url)"> 
								<a class="hyper_button ml-2" @click="downloadReport(item.report_url)"> 
									<img class="ml-1" src="../../assets/images/icons/solid/file.svg" width="18"/>
								</a>
							</td>
						</tr>
					</tbody>
		</table>
	
	<b-modal v-if="session_to_complete" hide-header v-model="complete_session_modal" @cancel="closeModal()" ok-title="Complete" @ok="completeSession()">
	<h6>Are you sure you want to mark the  "{{session_to_complete.name}}" session as Completed? <br> This action cannot be undone</h6>
		<!-- <h6> Are you sure to mark {{session_to_complete.name}} session as <b>Complete</b></h6> -->
	</b-modal>

	</div>
</template>
<script>
export default {
	props:{
		headers:{
			required: true
		},
		body:{
			required: true
		},
		section:{
			required: true
		}
	},
	computed : {
		user_view(){
			if(this.$store.getters.getRole == 'csm'){
				return 'admin'
			}else{
				return 'organization'
			}
		}
	},
	data: function(){
		return {
			complete_session_modal: false,
			session_to_complete: null
		}

	},
	methods:{
		openSession(elem){
			this.$emit("openViewSession", elem.id);
		},
		openSessionPlayer(e){
			let route  = null
			if(this.user_view == 'admin'){
				route = this.$router.resolve({ name :`${this.user_view}.session.view`, params:{id:this.$route.params.id, session_id: e.id, agency_id:this.$route.params.agency_id }})
			}
			else{
				route = this.$router.resolve({ name :`${this.user_view}.session.view`, params:{id:this.$route.params.id, session_id: e.id}})

			}
			window.open(route.href, '_blank');

		},
		downloadCert(cert_url){
			if(this.user_view == 'admin'){
				window.location.href = cert_url+`&organization_id=${this.$route.params.agency_id}`
			}else{
				window.location.href = cert_url
			}
		},
		openCompleteModal(session){
			this.session_to_complete = session
			this.complete_session_modal = true
		},
		completeSession(){
			var params = {
				id: this.session_to_complete.id,
				filters:this.session_to_complete
			}
			
			if(this.user_view == 'admin'){
				params.filters.organization_id = this.$route.params.agency_id
			}
			this.$store.dispatch('completeSession', this.session_to_complete).then((res) => {
				this.closeModal()
				this.$emit('getSessionList')
			})
		},
		closeModal(){
			this.complete_session_modal = false
			this.session_to_complete = null
		}
	}
}
</script>
<style>
.session_table > td{
	font-size: 15px;
    padding-left: 1.2rem;

}
.clickable{
	text-decoration: underline;
}
.border-50{
	border-radius: 50%;
}
.hyper_button{
	text-decoration: underline !important;
	cursor: pointer;
	color: #11a5a7 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/sessionTableView.vue